module.exports = __webpack_public_path__ + "static/media/poweredByStrava.7fa81960.svg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/Login/poweredByStrava.svg
// module id = 906
// module chunks = 1